import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FaExternalLinkAlt } from 'react-icons/fa';

export const LPLink: React.FC<{
  url: string;
}> = ({ url }) => {
  const { t } = useTranslation();
  return (
    <LPLinkWrapper>
      <a href={url} rel="noopener noreferrer" target="_blank">
        {t('ui.link.forMoreInfo')}
      </a>
      <FaExternalLinkAlt />
    </LPLinkWrapper>
  );
};

const LPLinkWrapper = styled.div`
  margin-top: 16px;
  color: #5281ff;
  text-decoration: underline;
  margin-bottom: 32px;
  display: flex;
  gap: 12px;
  align-items: center;
`;
